export namespace PaperlessDatalayer {
    // 1.00 Switch winning confirmation
    export function switchWinningConfirmation(isOn: boolean) {
        dataLayer.push({
            event: "action.switch.winningConfirmation",
            action: {
                switch: {
                    label: "account", // registration or account
                    eventProperty1: isOn ? "on" : "off", // on or off
                },
            },
        });
    }

    // 1.10 Confirmation of winning click - my bets (loterie and losy)
    export function confirmWinningClickMyBets(gameCode: string, verticalCode: string) {
        dataLayer.push({
            event: "action.click.winningConfirmation",
            action: {
                click: {
                    label: gameCode, // gameCode of clicked game
                    eventProperty1: "myBets." + verticalCode, // myBets. + verticalCode
                    eventProperty2: "winningConfirmation",
                },
            },
        });
    }

    // 1.20 Confirmation of winning click - detail (loterie and losy)
    export function confirmWinningClickDetail(gameCode: string, verticalCode: string) {
        dataLayer.push({
            event: "action.click.winningConfirmation",
            action: {
                click: {
                    label: gameCode, // gameCode of clicked game
                    eventProperty1: "detail." + verticalCode, // detail. + verticalCode
                    eventProperty2: "winningConfirmation",
                },
            },
        });
    }

    // 1.30 Downloading of winning ticket (loterie and losy)
    export function downloadWinningTicket(gameCode: string, verticalCode: string) {
        dataLayer.push({
            event: "action.download.winningConfirmation",
            action: {
                download: {
                    label: gameCode, // gameCode of the downloaded confirmation game
                    eventProperty1: verticalCode, // verticalCode of the downloaded confirmation vertical
                },
            },
        });
    }

    // 1.40 Opening My Receipts
    export function openMyReceipts() {
        dataLayer.push({
            event: "action.click.navigation",
            action: {
                click: {
                    label: "Moje uctenky", // click name
                    eventProperty1: "account",
                },
            },
        });
    }

    // 1.50 Receipt click
    export function receiptClick(gameCode: string, verticalCode: string) {
        dataLayer.push({
            event: "action.click.receipt",
            action: {
                click: {
                    label: gameCode, // gameCode on clicked receipt
                    eventProperty1: verticalCode, // verticalCode on clicked receipt
                },
            },
        });
    }

    // 1.60 Receipt download
    export function receiptDownload(gameCode: string, verticalCode: string) {
        dataLayer.push({
            event: "action.download.receipt",
            action: {
                download: {
                    label: gameCode, // gameCode on downloaded receipt
                    eventProperty1: verticalCode, // verticalCode on downloaded receipt
                },
            },
        });
    }
}
